var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["none"] = "none";
  Variant2["closedDate"] = "closedDate";
  Variant2["closedWeek"] = "closedWeek";
  Variant2["time"] = "time";
  Variant2["date"] = "date";
  Variant2["week"] = "week";
  Variant2["error"] = "error";
  return Variant2;
})(Variant || {});
export {
  Variant
};
//# sourceMappingURL=types.js.map
